import { IconButton } from "@material-ui/core";
import ArrowBackRoundedIcon from "@material-ui/icons/ArrowBackRounded";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import { resetHotspotEditor, setCurrentlyOpenModal } from "../../redux";
import { getCurrentlyOpenModal, getIsModified } from "../../redux/selectors";
import { modals } from "../../util/constants";
import { ConfirmReturnToFileSelection } from "../ConfirmReturnToFileSelection/ConfirmReturnToFileSelection";

export function BackButton() {
  const dispatch = useDispatch();
  const isModified = useSelector(getIsModified);
  const currentlyOpenModal = useSelector(getCurrentlyOpenModal);

  const resetTheApp = () => dispatch(resetHotspotEditor());
  const backButtonClickHandler = () => {
    if (isModified) {
      dispatch(setCurrentlyOpenModal(modals.confirmReturnToInputURL));
    } else {
      resetTheApp();
    }
  };
  return (
    <>
      <IconButton onClick={backButtonClickHandler}>
        <ArrowBackRoundedIcon color="primary" />
      </IconButton>

      <ConfirmReturnToFileSelection
        open={currentlyOpenModal === modals.confirmReturnToInputURL}
        OKAction={resetTheApp}
      />
    </>
  );
}
